export default __webpack_public_path__ + "static/doctor-img-ae6790b17d1cdfb6bbc2501ed4631fce.png";